import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Filter extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            content: null,
            more: null,
            toggles: [],
            mobileSortHolder: null,
            mobileNav: null
        }

        this.enquireHandler = {
            match: ::this.match,
            unmatch: ::this.unmatch
        }

        this.items = []
        this.active = false
        this.containerHeight = 0
        this.container = this.ref.more

        this.handleClick = ::this.handleClick
    }

    prepare() {
        if (this.ref.more) {
            this.items = this.ref.more.querySelectorAll('.filter-Item-button')
        }

        if (this.ref.toggles[1]) {
            this.button = this.ref.toggles[1]
            this.button.addEventListener('click', this.handleClick)
        }

        enquire.register(queries.smallWideMax, this.enquireHandler)
        window.addEventListener('resize', ::this.size)
        this.size()
    }

    destroy() {
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
    }

    match() {
        this.ref.content.style.maxHeight = 0
        this.container = this.ref.content
        this.items = this.container.querySelectorAll('.filter-Item:not(.filter-Item--sort) .filter-Item-button')
        const filterSort = this.element.querySelector('.filter-Item--sort')
        this.ref.mobileNav.appendChild(filterSort)

        if (this.ref.toggles[0]) {
            if (this.ref.toggles[1]) this.button.removeEventListener('click', this.handleClick)
            this.button = this.ref.toggles[0]
            this.button.addEventListener('click', this.handleClick)
        }
    }

    unmatch() {
        this.ref.content.style.maxHeight = "none"
        this.container = this.ref.more
        this.items = this.container.querySelectorAll('.filter-Item-button')
        const filterSort = this.element.querySelector('.filter-Item--sort')
        this.ref.content.insertBefore(filterSort, this.ref.content.firstChild)

        if (this.ref.toggles[1]) {
            if (this.ref.toggles[0]) this.button.removeEventListener('click', this.handleClick)
            this.button = this.ref.toggles[1]
            this.button.addEventListener('click', this.handleClick)
        }
    }

    size() {
        if (this.items[0]) {
            let top = this.items[0].getBoundingClientRect().top
            let bottom = this.items[this.items.length-1].getBoundingClientRect().bottom
            let margin = parseInt(window.getComputedStyle(this.items[0].closest('.filter-Item')).getPropertyValue('margin-bottom'))

            this.height = (bottom - top) + margin
        }
    }

    handleClick(event) {
        event.preventDefault()
        this.toggle()
    }

    toggle() {
        if (this.active) {
            if (this.button) {
                this.button.classList.remove(STATES.ACTIVE)
            }
            this.container.style.maxHeight = this.containerHeight + "px"
            this.container.style.overflow = 'hidden'

            if (this.timer) {
                clearTimeout(this.timer)
            }
        } else {
            if (this.button) {
                this.button.classList.add(STATES.ACTIVE)
            }
            this.container.style.maxHeight = this.height + 'px'

            this.timer = setTimeout(() => {
                this.container.style.overflow = 'visible'
            }, 600)
        }

        this.active = !this.active
    }
}